import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { LanguageSwitcher } from "../components/LanguageSwitcher";
import { RisographBackground } from "../components/RisographBackground";

const STARTER_PROMPTS = [
	"Tell me about a place from your childhood.",
	"What's a smell that takes you somewhere?",
	"Describe a meal you'll never forget.",
	"Tell me about someone who taught you something without knowing it.",
	"What's a sound that means home to you?",
];

export function OnboardingPromptsPage() {
	const navigate = useNavigate();
	const { t } = useTranslation();
	const [selected, setSelected] = useState<string | null>(null);

	function handleBegin() {
		if (!selected) return;
		navigate("/stories/new", {
			state: { promptContext: selected, inputMode: "voice" },
		});
	}

	return (
		<div className="relative min-h-screen">
			<RisographBackground />
			<main className="max-w-xl mx-auto px-6 pt-16 pb-16">
				<p className="font-ui text-[10px] uppercase tracking-[0.25em] text-ink/40 mb-3">
					{t("onboarding.prompts.eyebrow")}
				</p>
				<h1 className="font-display text-4xl font-bold text-ink leading-tight mb-3">
					{t("onboarding.prompts.headline")}
				</h1>
				<p className="font-body italic text-base text-ink/50 mb-10">
					{t("onboarding.prompts.subtext")}
				</p>

				<div className="flex flex-col gap-3 mb-8">
					{STARTER_PROMPTS.map((prompt) => (
						<button
							key={prompt}
							type="button"
							onClick={() => setSelected(prompt)}
							className={`w-full text-left bg-white/30 backdrop-blur-sm border rounded-sm p-5 transition-all ${
								selected === prompt
									? "border-ink/60 bg-white/50 shadow-sm"
									: "border-ink/10 hover:border-ink/30 hover:bg-white/40"
							}`}
						>
							<span className="font-body italic text-ink/80 text-base leading-relaxed">
								"{prompt}"
							</span>
						</button>
					))}
				</div>

				<p className="font-body italic text-sm text-ink/40 text-center mb-8">
					{t("onboarding.prompts.note")}
				</p>

				<button
					type="button"
					onClick={handleBegin}
					disabled={!selected}
					className="ink-btn w-full py-3.5 font-ui text-sm uppercase tracking-widest disabled:opacity-40 disabled:cursor-not-allowed"
				>
					{t("onboarding.prompts.cta")}
				</button>

				<div className="flex justify-center mt-8">
					<LanguageSwitcher />
				</div>
			</main>
		</div>
	);
}
